import { makeStyles, Grid } from "@material-ui/core";
import React from "react";
import { BookCard } from "../../../components";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "10px 0 30px 0",
    width: "100%",
  },
  sectionHeading: {
    fontSize: "24px",
    fontWeight: "600",
  },
}));

function RelatedBooks(props) {
  const classes = useStyles();
  const { books } = props;
  return (
    <div className={classes.root}>
      <h2 className={classes.sectionHeading}>Related Books</h2>
      <Grid container spacing={2}>
        {books.map((book) => (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <BookCard
              title={book.title}
              price={book.price}
              cover={book.cover}
              bookId={book.bookId}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default RelatedBooks;
